var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomizableWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.6004 16.817C35.5099 16.817 37.3413 16.0584 38.6916 14.7082C40.0418 13.3579 40.8004 11.5266 40.8004 9.61699C40.8004 7.70743 40.0418 5.87609 38.6916 4.52582C37.3413 3.17556 35.5099 2.41699 33.6004 2.41699C31.6908 2.41699 29.8595 3.17556 28.5092 4.52582C27.159 5.87609 26.4004 7.70743 26.4004 9.61699C26.4004 11.5266 27.159 13.3579 28.5092 14.7082C29.8595 16.0584 31.6908 16.817 33.6004 16.817Z",
    fill: "#0052FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1998 9.61719H4.7998V34.8172H43.1998V9.61719Z",
    fill: "#CED2DB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7998 34.8174V46.8174L4.7998 34.8174H34.7998Z",
    fill: "#0052FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7998 22.168V34.8172H4.7998V9.61719L34.7998 22.168ZM40.7998 9.61719C40.7998 11.5267 40.0412 13.3581 38.691 14.7084C37.3407 16.0586 35.5094 16.8172 33.5998 16.8172C31.6902 16.8172 29.8589 16.0586 28.5086 14.7084C27.1584 13.3581 26.3998 11.5267 26.3998 9.61719H40.7998Z",
    fill: "#101114"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomizableWallet);
export default __webpack_public_path__ + "static/media/customizable_wallet.cb3d2ffc65fd834b82df3f6ab0c0665b.svg";
export { ForwardRef as ReactComponent };